import React, { useEffect, useState } from "react";
import '../Css/Values.css';

const ValueEducation = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Start animation after scroll (add slight delay if needed)
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`value-education-container ${animate ? "animate" : ""}`}>
      <h2 className="value-title">
        <span className="gray">VALUES</span>{" "}
        <span className="green">EDUCATION</span>
        <div className="underline" />
      </h2>

      <p className="value-description">
        Once the interest is awakened, initialization of values in the life of the individual becomes the utmost need which can be achieved through systematic knowledge transmission.
      </p>

      <div className="value-content">
        <div className="value-list">
          <h3>Values Education Phase Topics</h3>
          <ul>
            <li>Knowing Values to Develop values</li>
            <li>Absolute Necessity of Value Education</li>
            <li>Decoding Success</li>
            <li>3 Point Success Formula</li>
            <li>PARTHA-The Success Formula</li>
            <li>Character and Competence</li>
            <li>Balance IQ, EQ and SQ</li>
            <li>Get Offline and Grow</li>
            <li>Faithology</li>
            <li>Personality Development</li>
            <li>8 Practical Tips for Positive Thinking</li>
            <li>Art of Becoming Happy</li>
            <li>Art of Decision Making</li>
            <li>Managing Distractions</li>
            <li>Getting out of Comfort Zone</li>
            <li>Life Lessons from Great Personalities</li>
            <li>Choosing and Keeping Friends</li>
            <li>Time Management</li>
            <li>Lifestyle Management</li>
          </ul>
        </div>
        <div className="value-image">
          <img src='/assets/edu-training/value-education.jpeg' alt="Values Education" />
        </div>
      </div>
    </div>
  );
};

export default ValueEducation;
